import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useConfirmCookie from "shared/model/useConfrimCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostUtilSmsConfirm = (contactRef, codeRef) => {

    const [fetchResult, fetchRequest] = useFetch()
    const [, setConfirmCookie] = useConfirmCookie()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("POST", "/admin/util/sms/confirm", {
            "contact": contactRef?.current?.value,
            "confirm_number": codeRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setConfirmCookie(fetchResult?.data?.token)
                break
            case 400:
                if (fetchResult?.data?.error_code === "contact") setAlert("연락처 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "confirm_number") setAlert("인증번호 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
            case 401:
                if (fetchResult?.data?.error_code === 1) setAlert("인증번호가 일치하지 않거나\n인증 시간이 만료되었습니다.")
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePostUtilSmsConfirm